// Generated by scripts/update-seeq-icons.js from src/svg/seeq/solid.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcSolid = {
  prefix: 'fak',
  iconName: 'solid' as IconName,
  icon: [1024, 1024, [], 'e99b', 'M0 465.9h1024v46.1h-1024v-46.1zM0 512h1024v46.1h-1024v-46.1z'],
} satisfies IconDefinition;
